const loadBeacon = 'loadBeacon';
const openBeaconChat = 'openChat';
const openBeaconChatPermanently = 'openChatPermanently';

export {
  loadBeacon,
  openBeaconChat,
  openBeaconChatPermanently
};